// Copyright (c) 2016 Deere & Company

import QuestionablePartSearch, {getDefaultState as getQuestionablePartSearchDefaultState} from '../state/report';
import actions from '../../actions-list';

const updateQuestionablePartSearchReport = (state, action) =>
QuestionablePartSearch.update(state, {
    $set: action.data
});

const resetQuestionablePartSearchReport = state =>
QuestionablePartSearch.update(state, {
    $set: getQuestionablePartSearchDefaultState()
});

export default (state = getQuestionablePartSearchDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_QUESTIONABLE_PART_SEARCH_REPORT_SUCCESS]: updateQuestionablePartSearchReport,
        [actions.RESET_QUESTIONABLE_PART_SEARCH_REPORT]: resetQuestionablePartSearchReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/reducers/report.js